module.exports = __webpack_public_path__ + "static/AMA20 Finalist Medal_Broker of the Year - Independent-09ba549bf18a15411e61d833059ef626.png";